'use client';

import React from 'react';
import { PageErrorBoundary } from '@/_components/page-error-boundary';

// Отлавливает ошибки, которые возникают в клиентской части приложения на страницах
// https://nextjs.org/docs/app/api-reference/file-conventions/error#reference
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <PageErrorBoundary error={error} reset={reset} />;
}
